import { render } from "./LeadAngelCarriedInterest.vue?vue&type=template&id=ff8affac&scoped=true&ts=true"
import script from "./LeadAngelCarriedInterest.vue?vue&type=script&lang=ts"
export * from "./LeadAngelCarriedInterest.vue?vue&type=script&lang=ts"

import "./LeadAngelCarriedInterest.vue?vue&type=style&index=0&id=ff8affac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8affac"]])

export default __exports__